import { MutationTree } from 'vuex';
import { VacationState } from './types';
import { VacationResource, UserVacationHourResource, VacationTypeResource} from '@/api/requests/vacation/types';
import Vue from 'vue';
import { SingleFilter } from '@/store/types';

export const mutations: MutationTree<VacationState> = {
    /** Vacations */

    /**
     * Add an vacation to the list.
     *
     * @param state
     * @param vacation
     */
    addVacation(state, vacation: VacationResource) {
        state.vacations.push(vacation);
    },

    /**
     * Remove an vacation from the list.
     *
     * @param state
     * @param vacationId
     */
    removeVacation(state, vacationId: number) {
        state.vacations = state.vacations.filter((vacation) => vacation.id !== vacationId);
    },

    /**
     * Set the vacations list.
     *
     * @param state
     * @param vacations
     */
    setVacations(state, vacations: VacationResource[]) {
        state.vacations = vacations;
    },


    /**
     * Reset vacations
     *
     * @param state
     */
    resetVacations(state) {
        state.vacations = [];
    },

    /**
     * Update an vacation.
     *
     * @param state
     * @param vacation
     */
    updateVacation(state, vacation: VacationResource) {
        const index = state.vacations.findIndex((item) => item.id === vacation.id);
        state.vacations.splice(index, 1, vacation);
    },

    /**
     * Set the active vacation id.
     *
     * @param state
     * @param id
     */
    setActiveVacationId(state, id: number) {
        state.activeVacationId = id;
    },

    /**
     * Update a vacation.
     *
     * @param state
     * @param task
     */
    upsertVacation(state, vacation: VacationResource) {
        const index = state.vacations.findIndex((item) => item.id === vacation.id);
        if (index > -1) {
            state.vacations.splice(index, 1, vacation);
        } else {
            state.vacations.push(vacation);
        }
    },

    /** Vacation Types */
    
    /**
     * Set the vacation types.
     *
     * @param state
     * @param vacations
     */
    setVacationTypes(state, vacationTypes: VacationTypeResource[]) {
        state.vacationTypes = vacationTypes;
    },

    /** User vacation hours */

    /**
     * Add a user vacation hour to the list.
     *
     * @param state
     * @param userVacationHour
     */
    addUserVacationHour(state, userVacationHour: UserVacationHourResource) {
        state.userVacationHours.push(userVacationHour);
    },

    /**
     * Remove a user vacation hour from the list.
     *
     * @param state
     * @param userVacationHourId
     */
    removeUserVacationHour(state, userVacationHourId: number) {
        state.userVacationHours = state.userVacationHours.filter((userVacationHour) => userVacationHour.id !== userVacationHourId);
    },

    /**
     * Set the user vacation hour.
     *
     * @param state
     * @param userVacationHours
     */
    setUserVacationHours(state, userVacationHours: UserVacationHourResource[]) {
        state.userVacationHours = userVacationHours;
    },


    /**
     * Reset user vacation hours.
     *
     * @param state
     */
    resetUserVacationHours(state) {
        state.userVacationHours = [];
    },

    /**
     * Update a user vacation hour.
     *
     * @param state
     * @param userVacationHour
     */
    updateUserVacationHour(state, userVacationHour: UserVacationHourResource) {
        const index = state.userVacationHours.findIndex((item) => item.id === userVacationHour.id);
        state.userVacationHours.splice(index, 1, userVacationHour);
    },

    /**
     * Set the active user vacation hour id.
     *
     * @param state
     * @param id
     */
    setActiveUserVacationHourId(state, id: number) {
        state.activeUserVacationHourId = id;
    },

    /**
     * Update a user vacation hour.
     *
     * @param state
     * @param task
     */
    upsertUserVacationHour(state, userVacationHour: UserVacationHourResource) {
        const index = state.userVacationHours.findIndex((item) => item.id === userVacationHour.id);
        if (index > -1) {
            state.userVacationHours.splice(index, 1, userVacationHour);
        } else {
            state.userVacationHours.push(userVacationHour);
        }
    },

    /** Filters */

    /**
     * Set a query filter in state.
     *
     * @param state
     * @param key
     * @param value
     */
     setFilter(state, { key, value }: SingleFilter) {
        state.filters = { ...state.filters, [key]: value };
    },

    /**
     * Reset a single filter.
     *
     * @param state
     * @param key
     */
    resetFilter(state, key: string) {
        delete state.filters[key];
    },


    /**
     * Reset query filters.
     *
     * @param state
     */
    resetFilters(state) {
        state.filters = {};
    },
};
